<template>
  <div class="fileupload">
    Monthly uploaded log files count: <span :class="checkClass">{{ currentFile }}</span> [limit: {{ limitFile }}]
    <b-form @submit="onSubmit" @reset="onReset">
      <b-container fluid >
        <b-row align-h="center">
          <b-col cols="10">
            <b-form-file
              v-model="file"
              :state="Boolean(file)"
              placeholder="Choose a log file or drop it here. (Max 100KB)"
              drop-placeholder="Drop file here..."
            ></b-form-file>
          </b-col>
        </b-row>
        <b-row align-h="end">
          <b-col align-self="end" cols="4">
            <b-button class="new-btn" @click="onReset" variant="danger">Reset</b-button>
            <b-button v-if="loading" variant="primary" disabled>
              <b-spinner small type="grow"></b-spinner>
                Uploading...
            </b-button>
            <b-button v-else :disabled="validateError" class="new-btn" @click="onSubmit" variant="primary">Upload</b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-form>
    <FileList ref="filelist"></FileList>
  </div>
</template>

<script>
import FileList from './FileList.vue'
import firebase from 'firebase'
import axios from 'axios'
const apiUrl = 'https://logcrow.appspot.com/'
// const apiUrl = 'http://192.168.212.101:9999/'
// const apiUrl = 'http://localhost:9999/'
export default {
  name: 'FileUpload',
  props: {},
  components: {
    FileList,
  },
  data() {
    return {
      file: null,
      invalidType: true,
      loading: false,
      limitFile: 0
    }
  },
  methods: {
    makeToast(variant = null, message) {
      this.$root.$bvToast.toast(message, {
        title: `${variant || 'message'}`,
        variant: variant,
        solid: true
      })
    },
    onSubmit() {
      this.loading = true
      let currentUser = firebase.auth().currentUser
      if (currentUser) {
        currentUser.getIdToken(true).then(async (idToken) => {
          let formData = new FormData()
          formData.append('uploadlog', this.file)
          await axios.post(apiUrl + 'file', formData, {
            headers: {
              'Authorization': `Bearer ${idToken}`,
              'Content-Type': 'multipart/form-data'
            }
          })
          this.makeToast('success', 'Uploaded log. Please wait for a while until the analysis is completed.')
          this.loading = false
          this.$refs.filelist.getFileInfoList()
          this.onReset()
          this.$router.push('/upload')
        }).catch(() => {
          this.makeToast('danger', "Failed to upload file...")
        })
      }
    },
    checkFileMimeType() {
      if( this.file.type.startsWith('text') || this.file.type === 'application/json' ) {
        this.invalidType = false
      }
      let reader = new FileReader();
      reader.onload = function(event) {
        let dataURL = event.target.result;
        let mimeType = dataURL.split(",")[0].split(":")[1].split(";")[0];
        if( mimeType === 'application/octet-stream' ) {
          this.invalidType = false
        }
      };
      reader.readAsDataURL( this.file );
    },
    onReset() {
      this.file = null
      this.invalidType = true
    },
    checkClass() {
      let threshold = 0.8
      if( this.currentLog <= this.limitLog * threshold ) {
        return "normal"
      } else if( this.currentLog < this.limitLog && this.currentLog > this.limitLog * threshold) {
        return "warning"
      } else {
        return "limit"
      }
    },
    getMyInfo() {
      let currentUser = firebase.auth().currentUser
      if (currentUser) {
        currentUser.getIdToken(true).then(async (idToken) => {
          let res = await axios.get(apiUrl + 'user', {
            headers: {
              'Authorization': `Bearer ${idToken}`
            }
          })
          if (res.status == 200) {
            this.limitFile = res.data.plan_obj.limit_file
          }
        }).catch(() => {
          this.makeToast('danger', 'connection error.')
        })
      }
    }
  },
  computed: {
    validateError() {
      if( this.file == null ) {
        return true
      }
      if( this.currentFile >= this.limitFile ) {
        return true
      }
      let maxUploadSize = 1024*100 // 100KB
      this.checkFileMimeType()
      if( this.invalidType && this.file.size < maxUploadSize ) {
        return false
      }
      return true
    },
    currentFile() {
      let files = this.$store.getters.files
      let count = 0
      let fromTime = new Date()
      fromTime.setDate(1)
      fromTime.setHours(0,0,0,0)
      for(let file of files) {
        let d = new Date(file.date)
        if( d >= fromTime ) {
          count++
        }
      }
      return count
    }
    
  },
  mounted: function() {
    this.getMyInfo()
  },
}
</script>

<style>
.new-btn {
    margin: 10px;
}
.fileupload {
  margin: 16px;
}
</style>
